import { useState } from 'react';

export const LazyImage = ({ src, alt, className = '', wrapperClassName = 'relative w-full h-full', eager = false, placeholder = null }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`${wrapperClassName} overflow-hidden bg-surface`}>
      {placeholder && (
        <div
          aria-hidden="true"
          className={`absolute inset-0 bg-cover bg-center blur-xl scale-110 transition-opacity duration-700 ${loaded ? 'opacity-0' : 'opacity-100'}`}
          style={{ backgroundImage: `url(${placeholder})` }}
        />
      )}
      {!loaded && !placeholder && <div className="absolute inset-0 animate-pulse bg-white/5 z-[1]" />}
      <img
        src={src}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        onLoad={() => setLoaded(true)}
        style={{ opacity: loaded ? undefined : 0 }}
        className={className}
      />
    </div>
  );
};
